import { AmplitudeEvent } from 'utils/amplitude/amplitudeEvents'

export const pageEventMap = {
  home: AmplitudeEvent.REWARDS_HOME,
  details: AmplitudeEvent.REWARDS_DETAILS,
}

export const formEventMap = {
  allocate: AmplitudeEvent.REWARDS_ALLOCATE_FUNDS_INITIATE,
  withdraw: AmplitudeEvent.REWARDS_WITHDRAW_FUNDS_INITIATE,
  removeAllocation: AmplitudeEvent.REWARDS_REMOVE_ALLOCATION_INITIATE,
}

export const cancelEventMap = {
  allocate: AmplitudeEvent.REWARDS_ALLOCATE_FUNDS_CANCEL,
  withdraw: AmplitudeEvent.REWARDS_WITHDRAW_FUNDS_CANCEL,
  removeAllocation: AmplitudeEvent.REWARDS_REMOVE_ALLOCATION_CANCEL,
}

export const successEventMap = {
  allocate: AmplitudeEvent.REWARDS_ALLOCATE_FUNDS_SUCCESS,
  withdraw: AmplitudeEvent.REWARDS_WITHDRAW_FUNDS_SUCCESS,
  removeAllocation: AmplitudeEvent.REWARDS_REMOVE_ALLOCATION_SUCCESS,
  createPortfolio: AmplitudeEvent.Rewards_ALLOCATE_FUNDS_CREATE_PORTFOLIO_SUCCESS,
}

export const errorEventMap = {
  allocate: AmplitudeEvent.REWARDS_ALLOCATE_FUNDS_ERROR,
  withdraw: AmplitudeEvent.REWARDS_WITHDRAW_FUNDS_ERROR,
  removeAllocation: AmplitudeEvent.REWARDS_REMOVE_ALLOCATION_ERROR,
  createPortfolio: AmplitudeEvent.Rewards_ALLOCATE_FUNDS_CREATE_PORTFOLIO_ERROR,
}
